/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */
import type { GridProps } from '@mui/material';
import { Grid, Typography } from '@mui/material';
import React from 'react';
import { styles } from '../ProductForm.styles';

interface ProductFormFieldLayoutProps extends GridProps {
  title?: string;
  children: React.ReactNode;
}

const ProductFormFieldLayout: React.FC<ProductFormFieldLayoutProps> = ({
  title,
  children,
  ...props
}: ProductFormFieldLayoutProps) => {
  return (
    <Grid container spacing={3} {...props}>
      <Grid
        container
        size={4}
        sx={{
          justifyContent: 'flex-end',
        }}
      >
        {!!title && (
          <Typography sx={styles.label} variant="subtitle1">
            {title}
          </Typography>
        )}
      </Grid>
      <Grid
        container
        size={8}
        sx={{
          justifyContent: 'flex-start',
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default ProductFormFieldLayout;
